import { render, staticRenderFns } from "./referenceForm.vue?vue&type=template&id=06c97e04&scoped=true&"
import script from "./referenceForm.vue?vue&type=script&lang=js&"
export * from "./referenceForm.vue?vue&type=script&lang=js&"
import style0 from "./referenceForm.vue?vue&type=style&index=0&id=06c97e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c97e04",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QRadio,QCheckbox,QBtn,QIcon});
